import React, {useEffect, Suspense} from 'react';
import {BrowserRouter as Router, Route, Redirect, Switch} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import GuardRoute from './Helpers/authGuard';
import {setUser} from "./store/User_store/actions";

import {connect} from "react-redux";
import Api from './Home/services/index'
import {message, Spin} from "antd";
import LocalStorageService from "./localStorage-service";
import App from "./App/App";

const Account = React.lazy(() => import('./Account/account'));
const Home = React.lazy(() => import('./Home/home'));

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
}

const checkIsAuth = () => {
    const token = LocalStorageService.getAuthToken();
    if (token) {
        const data = parseJwt(token);
        if (data.exp > (new Date().getTime())) {
            return true;
        } else {
            showMessage('error', 'Session is expired. Please log in again');
            LocalStorageService.logOut();
            return false;
        }
    } else {
        return false;
    }
};

const showMessage = (typeofMessage, content) => {
    message[typeofMessage]({content, style: {marginTop: '45px'}})
};


function Routes({history, setUser, loaders}) {
    const getCurrentUser = () => {
        Api.getUser().then(response => {
            setUser(response.user);
        }).catch(e => {
            showMessage('error', e.message)
        });
    }

    useEffect(() => {
        if (checkIsAuth()) {
            getCurrentUser();
        }
    });

    return (
        <Suspense fallback={<div></div>}>
            <Spin tip={loaders[0]}
                  spinning={!!loaders[0]}
                  style={{
                      minHeight: '100vh',
                      width: '100%',
                  }}
                  size="large">

                <Router history={history}>
                    <Switch>
                        <GuardRoute path='/app' component={App} auth={checkIsAuth}/>
                        <GuardRoute path='/account' component={Account} auth={checkIsAuth}/>
                        <Route exact path='/'
                               component={() => (checkIsAuth() ? <Redirect to='/account'/> : <Redirect to='/home'/>)}/>
                        <Route path={'/home'} component={Home}/>
                        <Route render={() => <Redirect to="/home"/>}/>
                    </Switch>
                </Router>
            </Spin>
        </Suspense>

    )
}

function mapStateToProps({schematicReducers: {loaders}}) {
    return {
        loaders
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setUser: (user) => {
            dispatch(setUser(user))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
